import LoadingSVG from './LoadingSVG';
import LogoSVG from './LogoSVG';
import PlanSVG from './PlanSVG';
import SlashSVG from './SlashSVG';
import SunraySVG from './SunraySVG';

export { LoadingSVG, LogoSVG, PlanSVG, SlashSVG, SunraySVG };
